module.exports = __webpack_public_path__ + "static/media/weather.7101dc88.png";